/*!
 * Copyright (c) 2022 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

module.exports = {
  CONTEXT_FILENAME: 'data-integrity-v1.jsonld',
  CONTEXT_URL: 'https://w3id.org/security/data-integrity/v1',
  CBORLD_VALUE: 0x30
};
